export const categoryVideos = {
  'mingxing-bagua': [
    {
      id: 'v001',
      title: '某顶流小生深夜密会神秘女子，酒店共度8小时',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20paparazzi%20style%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20dim%20streetlights%20and%20silhouettes%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20tones%2C%20noir%20aesthetic%2C%20high%20contrast%20photography&width=800&height=450&seq=cat-video-001&orientation=landscape',
      category: '明星八卦',
      views: '128.6万',
      comments: 3842,
      publishTime: '2026-06-28',
      isHot: true,
      isNew: false,
      duration: '08:24',
      excerpt: '狗仔蹲守72小时拍到的重磅画面...',
    },
    {
      id: 'v003',
      title: '某女星综艺现场发飙摔话筒，导演组紧急叫停',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20TV%20studio%20set%20with%20spotlight%20and%20microphone%20on%20floor%2C%20tense%20atmosphere%2C%20low%20key%20lighting%2C%20cinematic%20mood%2C%20behind%20the%20scenes%20aesthetic%2C%20dark%20surroundings%20with%20single%20dramatic%20light%20beam&width=800&height=450&seq=cat-video-003&orientation=landscape',
      category: '明星八卦',
      views: '215.8万',
      comments: 8921,
      publishTime: '2026-06-27',
      isHot: true,
      isNew: false,
      duration: '05:37',
      excerpt: '综艺录制现场突发状况，全场震惊...',
    },
    {
      id: 'v005',
      title: '某男团成员被拍到与女经纪人亲密互动',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20night%20street%20scene%20with%20two%20shadowy%20figures%20walking%20closely%20together%2C%20paparazzi%20long%20lens%20style%2C%20grainy%20texture%2C%20low%20light%20urban%20setting%2C%20suspenseful%20mood%2C%20noir%20photography&width=800&height=450&seq=cat-video-005&orientation=landscape',
      category: '明星八卦',
      views: '76.5万',
      comments: 1892,
      publishTime: '2026-06-26',
      isHot: false,
      isNew: true,
      duration: '06:15',
      excerpt: '粉丝心碎现场，爱豆恋情曝光...',
    },
    {
      id: 'v007',
      title: '某影后离婚内幕：第三者竟是圈内知名导演',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20film%20set%20with%20clapperboard%20and%20broken%20heart%20symbolism%2C%20moody%20lighting%2C%20scandal%20theme%2C%20noir%20cinematography%2C%20deep%20shadows%20and%20dramatic%20contrast&width=800&height=450&seq=cat-video-007&orientation=landscape',
      category: '明星八卦',
      views: '352.1万',
      comments: 15678,
      publishTime: '2026-06-25',
      isHot: true,
      isNew: false,
      duration: '22:18',
      excerpt: '知情人士独家爆料，细节触目惊心...',
    },
    {
      id: 'v008',
      title: '某小鲜肉被爆同时交往三位女粉丝，聊天记录流出',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20scene%20with%20smartphone%20screen%20glowing%20in%20darkness%20showing%20chat%20messages%2C%20mysterious%20atmosphere%2C%20privacy%20breach%20theme%2C%20noir%20style%2C%20low%20key%20lighting&width=800&height=450&seq=cat-video-008&orientation=landscape',
      category: '明星八卦',
      views: '89.3万',
      comments: 4521,
      publishTime: '2026-06-24',
      isHot: false,
      isNew: false,
      duration: '11:42',
      excerpt: '聊天记录细节曝光，人设彻底崩塌...',
    },
    {
      id: 'v009',
      title: '某女歌手新恋情曝光，男友身份令人意外',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20romantic%20night%20scene%20of%20two%20silhouettes%20holding%20hands%20on%20a%20rooftop%2C%20city%20lights%20blurred%20background%2C%20mysterious%20couple%2C%20noir%20photography%2C%20cinematic%20atmosphere&width=800&height=450&seq=cat-video-009&orientation=landscape',
      category: '明星八卦',
      views: '167.4万',
      comments: 7234,
      publishTime: '2026-06-23',
      isHot: false,
      isNew: false,
      duration: '09:55',
      excerpt: '圈内人：这段恋情已经持续半年...',
    },
  ],
  'wanghong-heiliao': [
    {
      id: 'v002',
      title: '知名带货网红翻车！被扒售卖假货证据确凿',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20luxury%20cosmetics%20and%20products%20on%20a%20dark%20surface%20with%20dramatic%20side%20lighting%2C%20counterfeit%20goods%20theme%2C%20mysterious%20atmosphere%2C%20high%20contrast%20shadows%2C%20noir%20style&width=800&height=450&seq=cat-video-002&orientation=landscape',
      category: '网红黑料',
      views: '96.3万',
      comments: 2156,
      publishTime: '2026-06-27',
      isHot: true,
      isNew: false,
      duration: '12:58',
      excerpt: '买家晒出鉴定报告，实锤假货...',
    },
    {
      id: 'v006',
      title: '网红圈大地震！多位头部主播涉嫌税务问题',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20scene%20with%20stacks%20of%20paper%20money%20and%20documents%20on%20a%20dark%20table%2C%20dramatic%20top%20lighting%2C%20financial%20scandal%20theme%2C%20noir%20aesthetic%2C%20deep%20contrast%20shadows&width=800&height=450&seq=cat-video-006&orientation=landscape',
      category: '网红黑料',
      views: '342.1万',
      comments: 12567,
      publishTime: '2026-06-25',
      isHot: true,
      isNew: false,
      duration: '18:33',
      excerpt: '税务部门已介入调查，金额惊人...',
    },
    {
      id: 'v010',
      title: '某美食博主被曝全是剧本，连探店都是安排好的',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20an%20empty%20restaurant%20with%20a%20single%20table%20set%20for%20filming%2C%20camera%20equipment%20visible%2C%20staged%20scene%20aesthetic%2C%20moody%20lighting%2C%20noir%20style&width=800&height=450&seq=cat-video-010&orientation=landscape',
      category: '网红黑料',
      views: '78.2万',
      comments: 3234,
      publishTime: '2026-06-26',
      isHot: false,
      isNew: true,
      duration: '14:21',
      excerpt: '前员工爆料：一切都是剧本...',
    },
    {
      id: 'v011',
      title: '知名健身网红身材造假实锤，P图前后对比惊人',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20gym%20scene%20with%20dumbbells%20and%20mirror%2C%20split%20screen%20before%20and%20after%20theme%2C%20dramatic%20lighting%2C%20deception%20reveal%20vibe%2C%20noir%20style%2C%20high%20contrast&width=800&height=450&seq=cat-video-011&orientation=landscape',
      category: '网红黑料',
      views: '134.6万',
      comments: 6754,
      publishTime: '2026-06-24',
      isHot: false,
      isNew: false,
      duration: '10:15',
      excerpt: '专业人士逐帧分析，P图痕迹明显...',
    },
    {
      id: 'v012',
      title: '某情感博主私生活大曝光：台上教人谈恋爱，台下出轨',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20a%20broken%20heart%20shaped%20neon%20sign%20in%20a%20dark%20room%2C%20relationship%20drama%20theme%2C%20moody%20lighting%2C%20noir%20aesthetic%2C%20emotional%20atmosphere&width=800&height=450&seq=cat-video-012&orientation=landscape',
      category: '网红黑料',
      views: '56.8万',
      comments: 2891,
      publishTime: '2026-06-23',
      isHot: false,
      isNew: false,
      duration: '07:38',
      excerpt: '粉丝心碎：原来你在骗我们...',
    },
    {
      id: 'v013',
      title: '某游戏主播代打实锤，直播画面与操作不符',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20gaming%20setup%20scene%20with%20monitor%20glow%20in%20darkness%2C%20keyboard%20and%20mouse%2C%20mysterious%20atmosphere%2C%20cheating%20theme%2C%20noir%20style%2C%20low%20key%20lighting&width=800&height=450&seq=cat-video-013&orientation=landscape',
      category: '网红黑料',
      views: '92.1万',
      comments: 4102,
      publishTime: '2026-06-22',
      isHot: false,
      isNew: false,
      duration: '16:09',
      excerpt: '慢放对比：手速和画面完全不同步...',
    },
  ],
  'baozou-shipin': [
    {
      id: 'v014',
      title: '综艺节目史上最尴尬名场面合集，笑到肚子疼',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20set%20with%20multiple%20monitors%20showing%20funny%20moments%2C%20entertainment%20show%20theme%2C%20dramatic%20stage%20lighting%2C%20noir%20aesthetic%2C%20contrast&width=800&height=450&seq=cat-video-014&orientation=landscape',
      category: '暴走视频',
      views: '286.3万',
      comments: 14532,
      publishTime: '2026-06-28',
      isHot: true,
      isNew: true,
      duration: '25:47',
      excerpt: '全程高能！每一帧都是表情包...',
    },
    {
      id: 'v015',
      title: '某明星活动现场被粉丝当场质问，表情管理失败',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20event%20stage%20scene%20with%20spotlight%20on%20empty%20microphone%20stand%2C%20tense%20atmosphere%2C%20confrontation%20theme%2C%20dramatic%20lighting%2C%20noir%20photography&width=800&height=450&seq=cat-video-015&orientation=landscape',
      category: '暴走视频',
      views: '178.9万',
      comments: 8967,
      publishTime: '2026-06-27',
      isHot: false,
      isNew: true,
      duration: '04:52',
      excerpt: '粉丝直怼偶像，现场气氛凝固...',
    },
    {
      id: 'v016',
      title: '直播事故大合集：主播崩溃瞬间TOP20',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20streaming%20setup%20scene%20with%20ring%20light%20and%20multiple%20screens%2C%20glitchy%20aesthetic%2C%20moody%20bedroom%20streamer%20vibe%2C%20noir%20style%2C%20dramatic%20contrast&width=800&height=450&seq=cat-video-016&orientation=landscape',
      category: '暴走视频',
      views: '423.5万',
      comments: 23456,
      publishTime: '2026-06-26',
      isHot: true,
      isNew: false,
      duration: '32:15',
      excerpt: '整整半小时的快乐源泉...',
    },
    {
      id: 'v017',
      title: '某歌手现场演唱车祸名场面，观众表情亮了',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20concert%20stage%20with%20spotlight%20and%20microphone%2C%20dramatic%20performance%20scene%2C%20empty%20stage%20aesthetic%2C%20moody%20lighting%2C%20noir%20music%20photography&width=800&height=450&seq=cat-video-017&orientation=landscape',
      category: '暴走视频',
      views: '156.2万',
      comments: 7834,
      publishTime: '2026-06-25',
      isHot: false,
      isNew: false,
      duration: '03:28',
      excerpt: '开口跪，这次是真的跪了...',
    },
    {
      id: 'v018',
      title: '红毯翻车名场面：女星摔跤、男星踩裙摆',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20red%20carpet%20scene%20with%20dramatic%20lighting%20and%20velvet%20ropes%2C%20empty%20celebrity%20walkway%2C%20glamorous%20yet%20moody%20atmosphere%2C%20noir%20style&width=800&height=450&seq=cat-video-018&orientation=landscape',
      category: '暴走视频',
      views: '198.7万',
      comments: 10234,
      publishTime: '2026-06-24',
      isHot: false,
      isNew: false,
      duration: '08:41',
      excerpt: '红毯名场面全收录，笑不活了...',
    },
    {
      id: 'v019',
      title: '综艺游戏环节失控现场，MC都拦不住了',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20game%20show%20set%20with%20props%20scattered%20around%2C%20chaotic%20scene%2C%20dramatic%20stage%20lighting%2C%20entertainment%20chaos%20theme%2C%20noir%20style&width=800&height=450&seq=cat-video-019&orientation=landscape',
      category: '暴走视频',
      views: '234.1万',
      comments: 11876,
      publishTime: '2026-06-23',
      isHot: false,
      isNew: false,
      duration: '11:23',
      excerpt: '游戏玩到失控，节目效果拉满...',
    },
  ],
  'neimu-dagua': [
    {
      id: 'v004',
      title: '内部人员爆料：某综艺节目黑幕操作曝光',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20office%20scene%20with%20confidential%20documents%20on%20a%20desk%20under%20dim%20desk%20lamp%2C%20whistleblower%20theme%2C%20leaked%20information%20vibe%2C%20noir%20filmmaking%20style%2C%20deep%20shadows&width=800&height=450&seq=cat-video-004&orientation=landscape',
      category: '内幕大瓜',
      views: '187.2万',
      comments: 5634,
      publishTime: '2026-06-26',
      isHot: false,
      isNew: true,
      duration: '15:42',
      excerpt: '前工作人员匿名投稿，揭综艺潜规则...',
    },
    {
      id: 'v020',
      title: '某选秀节目投票造假内幕：经纪公司买票证据曝光',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20scene%20with%20voting%20ballot%20box%20and%20scattered%20papers%2C%20election%20fraud%20theme%2C%20dramatic%20lighting%2C%20corruption%20exposed%2C%20noir%20style%2C%20moody%20atmosphere&width=800&height=450&seq=cat-video-020&orientation=landscape',
      category: '内幕大瓜',
      views: '245.6万',
      comments: 12890,
      publishTime: '2026-06-28',
      isHot: true,
      isNew: true,
      duration: '20:15',
      excerpt: '数据异常被扒出，投票系统形同虚设...',
    },
    {
      id: 'v021',
      title: '某经纪公司压榨艺人内幕：合同条款触目惊心',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20legal%20document%20and%20contract%20on%20table%20with%20dramatic%20shadow%2C%20law%20theme%2C%20exploitation%20reveal%2C%20moody%20noir%20lighting%2C%20corporate%20secrecy%20aesthetic&width=800&height=450&seq=cat-video-021&orientation=landscape',
      category: '内幕大瓜',
      views: '112.3万',
      comments: 5432,
      publishTime: '2026-06-25',
      isHot: false,
      isNew: false,
      duration: '17:09',
      excerpt: '前法务顾问爆料，合同处处是坑...',
    },
    {
      id: 'v022',
      title: '娱乐圈资源争夺战：某女星靠关系挤走原定女主',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20director%20chair%20and%20script%20on%20it%2C%20behind%20the%20scenes%20drama%2C%20power%20struggle%20theme%2C%20moody%20lighting%2C%20noir%20cinema&width=800&height=450&seq=cat-video-022&orientation=landscape',
      category: '内幕大瓜',
      views: '89.7万',
      comments: 4123,
      publishTime: '2026-06-24',
      isHot: false,
      isNew: false,
      duration: '13:44',
      excerpt: '剧组内部人士：选角名单被临时更换...',
    },
    {
      id: 'v023',
      title: '某颁奖礼内定名单提前泄露，获奖者早已确定',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20award%20ceremony%20scene%20with%20golden%20trophy%20in%20spotlight%2C%20corruption%20theme%2C%20dramatic%20stage%20lighting%2C%20scandal%20reveal%2C%20noir%20photography&width=800&height=450&seq=cat-video-023&orientation=landscape',
      category: '内幕大瓜',
      views: '156.4万',
      comments: 7654,
      publishTime: '2026-06-23',
      isHot: false,
      isNew: false,
      duration: '19:28',
      excerpt: '内部文件流出，评选机制形同虚设...',
    },
    {
      id: 'v024',
      title: '娱乐圈洗钱内幕：某影视公司利用电影项目转移资金',
      coverImage: 'https://readdy.ai/api/search-image?query=Dark%20financial%20document%20scene%20with%20calculator%20and%20banknotes%20in%20dramatic%20lighting%2C%20money%20laundering%20theme%2C%20corporate%20crime%2C%20noir%20style%2C%20moody%20atmosphere&width=800&height=450&seq=cat-video-024&orientation=landscape',
      category: '内幕大瓜',
      views: '67.8万',
      comments: 3210,
      publishTime: '2026-06-22',
      isHot: false,
      isNew: false,
      duration: '26:52',
      excerpt: '金融从业者深度分析：资金流向存疑...',
    },
  ],
};

export const videoDetails = {
  v001: {
    id: 'v001',
    title: '某顶流小生深夜密会神秘女子，酒店共度8小时',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20paparazzi%20style%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20dim%20streetlights%20and%20silhouettes%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20tones%2C%20noir%20aesthetic%2C%20high%20contrast%20photography%20with%20deep%20shadows%20and%20isolated%20light%20sources&width=1200&height=675&seq=detail-v001&orientation=landscape',
    category: '明星八卦',
    views: '128.6万',
    comments: 3842,
    publishTime: '2026-06-28 02:15',
    duration: '08:24',
    content: '据知情人士透露，某顶流男星近日被拍到深夜驾车前往某五星级酒店，与一名神秘女子前后进入酒店大堂。狗仔团队连续蹲守72小时后，拍到了该男星与女子在凌晨时分共同离开的画面。\n\n据酒店内部人员透露，两人在酒店内共度约8小时...该女子身份尚未确认，有爆料称可能是圈内某知名制片人。\n\n目前该男星工作室尚未对此事作出回应。粉丝后援会则发表声明称"艺人私生活请勿过度关注"。但这一回应反而引发了更多猜测...\n\n更多细节请观看完整视频。',
    tags: ['顶流男星', '深夜密会', '酒店', '恋情曝光', '狗仔爆料'],
  },
  v002: {
    id: 'v002',
    title: '知名带货网红翻车！被扒售卖假货证据确凿',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20luxury%20cosmetics%20and%20products%20on%20a%20dark%20surface%20with%20dramatic%20side%20lighting%2C%20counterfeit%20goods%20theme%2C%20mysterious%20atmosphere%2C%20high%20contrast%20shadows%2C%20noir%20style%2C%20deep%20dark%20background&width=1200&height=675&seq=detail-v002&orientation=landscape',
    category: '网红黑料',
    views: '96.3万',
    comments: 2156,
    publishTime: '2026-06-27 18:42',
    duration: '12:58',
    content: '近日，拥有2000万粉丝的某头部带货网红被多位买家联合举报，指控其直播间售卖的"国际大牌护肤品"实为假冒产品。\n\n多名买家晒出了专业鉴定机构的检测报告，报告显示产品成分与正品严重不符。更令人震惊的是，部分产品甚至含有超标的有害物质。\n\n该网红此前曾在直播间信誓旦旦地承诺"假一赔十"，但面对买家维权时却态度敷衍...\n\n目前平台已介入调查，该网红直播间已被暂时关闭。',
    tags: ['带货网红', '假货', '直播翻车', '消费者维权', '鉴定报告'],
  },
  v003: {
    id: 'v003',
    title: '某女星综艺现场发飙摔话筒，导演组紧急叫停',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20TV%20studio%20set%20with%20spotlight%20and%20microphone%20on%20floor%2C%20tense%20atmosphere%2C%20low%20key%20lighting%2C%20cinematic%20mood%2C%20behind%20the%20scenes%20aesthetic%2C%20dark%20surroundings%20with%20single%20dramatic%20light%20beam&width=1200&height=675&seq=detail-v003&orientation=landscape',
    category: '明星八卦',
    views: '215.8万',
    comments: 8921,
    publishTime: '2026-06-27 21:30',
    duration: '05:37',
    content: '某综艺节目录制现场突发意外状况。据现场观众爆料，某女星在游戏环节结束后突然情绪失控，当场将话筒摔在地上并大声质问节目组。\n\n现场目击者称，该女星疑似对节目组的游戏规则安排不满，认为节目组有意针对她设计不公平的环节。\n\n导演组紧急叫停录制，现场一度陷入尴尬沉默...\n\n该女星经纪人事后回应称"艺人身体不适导致情绪波动"，但网友显然不买账。',
    tags: ['综艺现场', '女星发飙', '摔话筒', '节目组冲突', '录制事故'],
  },
  v006: {
    id: 'v006',
    title: '网红圈大地震！多位头部主播涉嫌税务问题',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20scene%20with%20stacks%20of%20paper%20money%20and%20documents%20on%20a%20dark%20table%2C%20dramatic%20top%20lighting%2C%20financial%20scandal%20theme%2C%20noir%20aesthetic%2C%20deep%20contrast%20shadows&width=1200&height=675&seq=detail-v006&orientation=landscape',
    category: '网红黑料',
    views: '342.1万',
    comments: 12567,
    publishTime: '2026-06-25 08:00',
    duration: '18:33',
    content: '一场席卷网红圈的税务风暴正在酝酿。据权威消息源透露，税务部门近期对多位头部直播带货主播进行了税务稽查，涉及金额可能高达数亿元。\n\n据悉，部分主播通过注册多家空壳公司、虚报成本、隐瞒收入等方式少缴税款。目前已有至少5位粉丝量超千万的主播被约谈...\n\n这让人不禁想起此前某明星的税务风波，这次网红圈的"地震"会波及多广？',
    tags: ['网红税务', '逃税', '头部主播', '稽查', '补税'],
  },
};

export const mockComments = [
  {
    id: 'c001',
    user: '吃瓜一线猹',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20silhouette%2C%20mysterious%20person%2C%20low%20key%20lighting%2C%20noir%20style%20headshot%2C%20dramatic%20shadow&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    content: '我靠！这个料也太猛了吧，怪不得最近他都不怎么更新动态了，原来是在躲风头！',
    likes: 3842,
    time: '2小时前',
    replies: [
      {
        id: 'cr001',
        user: '深夜吃瓜人',
        avatar: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20portrait%20with%20half%20face%20in%20shadow%2C%20anonymous%20person%2C%20low%20key%20lighting%2C%20noir%20photography%2C%20dramatic%20contrast&width=80&height=80&seq=reply-avatar-01&orientation=squarish',
        content: '是啊，我关注他好久了，最近确实异常。工作室也不发声明，越沉默越有问题。',
        likes: 892,
        time: '1小时前',
      },
      {
        id: 'cr002',
        user: '吃瓜不信瓜',
        avatar: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20portrait%20of%20anonymous%20figure%2C%20profile%20view%2C%20mysterious%20person%2C%20low%20key%20noir%20headshot%2C%20deep%20shadows&width=80&height=80&seq=reply-avatar-02&orientation=squarish',
        content: '先观望一下，等官方回应。不过这个up主之前的料都是真的，这次估计也八九不离十。',
        likes: 456,
        time: '45分钟前',
      },
    ],
  },
  {
    id: 'c002',
    user: '娱乐圈观察家',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20of%20professional%20looking%20person%2C%20half%20face%20visible%2C%20low%20key%20lighting%2C%20noir%20headshot%2C%20mysterious%20atmosphere&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    content: '作为圈内人我可以说一句，这个爆料80%的内容是属实的。剩下的20%因为一些原因不能多说，懂的都懂。建议大家蹲后续。',
    likes: 2156,
    time: '5小时前',
    replies: [
      {
        id: 'cr003',
        user: '猹猹爱吃瓜',
        avatar: 'https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20anonymous%20figure%20looking%20up%2C%20mysterious%20person%2C%20low%20key%20noir%20lighting%2C%20dramatic%20shadow%2C%20dark%20monochrome&width=80&height=80&seq=reply-avatar-03&orientation=squarish',
        content: '大佬多说点啊！我们吃瓜群众就靠你了！',
        likes: 234,
        time: '4小时前',
      },
    ],
  },
  {
    id: 'c003',
    user: '理性吃瓜bot',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20looking%20slightly%20down%2C%20contemplative%20expression%2C%20low%20key%20lighting%2C%20noir%20style%2C%20mysterious%20atmosphere&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    content: '建议大家理性吃瓜。虽然我也很震惊，但还是等官方回应。不过有一说一，视频里的证据确实很硬，不像编的。',
    likes: 1567,
    time: '8小时前',
    replies: [],
  },
  {
    id: 'c004',
    user: '半夜不睡觉',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20sleepy%20looking%20person%20in%20shadow%2C%20night%20owl%20vibe%2C%20low%20key%20lighting%2C%20noir%20headshot%2C%20mysterious%20atmosphere&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
    content: '凌晨三点刷到这个视频，直接给我整清醒了。这瓜保熟吗？感觉比追剧还精彩！',
    likes: 892,
    time: '10小时前',
    replies: [
      {
        id: 'cr004',
        user: '早起的猹有瓜吃',
        avatar: 'https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20alert%20looking%20anonymous%20person%2C%20morning%20vibe%2C%20low%20key%20lighting%2C%20noir%20style%2C%20dramatic%20shadow&width=80&height=80&seq=reply-avatar-04&orientation=squarish',
        content: '哈哈哈哈+1 我也刚醒就看到这个，今天上班摸鱼有料了',
        likes: 145,
        time: '9小时前',
      },
    ],
  },
  {
    id: 'c005',
    user: '真相挖掘机',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20portrait%20of%20investigative%20looking%20person%20in%20shadow%2C%20serious%20expression%2C%20low%20key%20noir%20lighting%2C%20mysterious%20atmosphere&width=80&height=80&seq=comment-avatar-05&orientation=squarish',
    content: '补充一下背景信息：这个酒店确实是圈内人经常秘密约见的地方。我之前扒过的好几个料都跟这个酒店有关。地址在XX路，安保很严但是内部有熟人能拍到。',
    likes: 1234,
    time: '12小时前',
    replies: [],
  },
];

export const categoryInfo = {
  'mingxing-bagua': {
    name: '明星八卦',
    icon: 'ri-star-smile-line',
    description: '娱乐圈最新爆料，明星私生活大起底。从顶流小生到老牌影后，这里有你从未见过的娱乐圈真相。',
    count: 1286,
    keywords: '明星八卦,娱乐圈爆料,明星恋情,明星丑闻',
  },
  'wanghong-heiliao': {
    name: '网红黑料',
    icon: 'ri-user-smile-line',
    description: '网红圈翻车实录，人设崩塌现场。那些光鲜亮丽的网红背后，藏着多少不为人知的秘密？',
    count: 953,
    keywords: '网红黑料,带货翻车,主播内幕,网红人设崩塌',
  },
  'baozou-shipin': {
    name: '暴走视频',
    icon: 'ri-fire-line',
    description: '高能名场面合集，看完直呼好家伙。综艺事故、红毯翻车、直播崩坏，每一秒都是快乐源泉。',
    count: 742,
    keywords: '暴走视频,综艺名场面,直播事故,搞笑合集',
  },
  'neimu-dagua': {
    name: '内幕大瓜',
    icon: 'ri-spy-line',
    description: '圈内人爆料，一手内幕消息。来自前员工、业内线人的独家投稿，揭开娱乐圈最阴暗的一面。',
    count: 611,
    keywords: '内幕爆料,圈内人爆料,娱乐圈黑幕,行业潜规则',
  },
};

export function getAllVideoSummaries() {
  return Object.values(categoryVideos).flat();
}

export function getVideoDetail(id: string) {
  const existing = videoDetails[id as keyof typeof videoDetails];

  if (existing) {
    return existing;
  }

  const summary = getAllVideoSummaries().find((video) => video.id === id);

  if (!summary) {
    return undefined;
  }

  const categorySlug = Object.entries(categoryVideos).find(([, videos]) =>
    videos.some((video) => video.id === id)
  )?.[0] as keyof typeof categoryInfo | undefined;
  const info = categorySlug ? categoryInfo[categorySlug] : undefined;

  return {
    id: summary.id,
    title: summary.title,
    coverImage: summary.coverImage,
    category: summary.category,
    views: summary.views,
    comments: summary.comments,
    publishTime: `${summary.publishTime} 00:00`,
    duration: summary.duration,
    content: `${summary.excerpt}\n\n${info?.description || '黑料视频编辑部持续追踪事件进展，整理当前公开线索和频道内最新反馈。'}\n\n更多同类视频和后续动态会在完成基础核实后同步更新，方便读者集中查看最新进展。`,
    tags: [summary.category, '黑料视频', '每日更新', '吃瓜爆料'],
  };
}

export function getAllVideoDetails() {
  return getAllVideoSummaries()
    .map((video) => getVideoDetail(video.id))
    .filter((video): video is NonNullable<ReturnType<typeof getVideoDetail>> => Boolean(video));
}
